import { render, staticRenderFns } from "./TheLayoutFab.vue?vue&type=template&id=77f957d5"
import script from "./TheLayoutFab.vue?vue&type=script&lang=js"
export * from "./TheLayoutFab.vue?vue&type=script&lang=js"
import style0 from "./TheLayoutFab.vue?vue&type=style&index=0&id=77f957d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports